import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportPrognosisComponent } from './transport-prognosis.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    TransportPrognosisComponent]
})
export class TransportPrognosisModule { }
